import StatGrid from '@commons/stats'
import Column from '@components/column'
import SectionHeading from '@commons/headings/section'
import Tabs from '@commons/tabs'
import ActiveInstitutions from './components/actives'
import RequestInstitutions from './components/requests'
const AdminInstitutionsPage = () => {
  const items: any = [
    {
      title: 'Total Clinics',
      value: '155',
      icon: 'clinic',
      bg: 'danger50',
    },
    {
      title: 'Total Pharmacy',
      value: '23',
      icon: 'doctor',
      bg: 'primary100',
    },
    {
      title: 'Total Patients',
      value: '23',
      icon: 'patient',
      bg: 'green100',
    },
    {
      title: 'Total Appointments',
      value: '23',
      icon: 'appointment',
      bg: 'yellow100',
    },
    {
      title: 'Total Lab Orders',
      value: '23',
      icon: 'appointment',
      bg: 'orange100',
    },
    {
      title: 'Pending Lab Orders',
      value: '23',
      icon: 'lab',
      bg: 'yellow150',
    },
    {
      title: 'Registration Requests',
      value: '23',
      icon: 'users',
      bg: 'green150',
    },
    {
      title: 'Total Earning',
      value: 'Rs.23',
      icon: 'money',
      bg: 'yellow50',
    },
  ]
  const tabs = [
    {
      title: 'Registration Requests',
      key: 'request-institutions',
      Component: RequestInstitutions,
    },
    {
      title: 'Active Institution List',
      key: 'active-institutions',
      Component: ActiveInstitutions,
    },
  ]
  return (
    <>
      <StatGrid items={items} />
      <Column styleColumn="margin-top:20px;margin-bottom:20px;">
        <SectionHeading title="Institution Management" />
      </Column>
      <Tabs items={tabs} />
    </>
  )
}

export default AdminInstitutionsPage
